<template>
  <HeaderTrade/> 
  <!-- Container Start { -->
  <div id="container">
    <!-- Contents Start { -->
    <div id="contents">

      <!-- content start -->
      <div class="contents-area">
        
        <div class="top-nav-tab">
          <ul>
            <li><router-link :to="{ name: 'Notice'}">공지사항</router-link></li>
            <li><router-link :to="{ name: 'Qna'}" class="active">1:1문의</router-link></li>
          </ul>
        </div>

        <!-- qna start { -->
        <div class="qna">
          <div
            v-for="(item, index) in qnaLists"
            :key = index           
          >
            <div
              class="qna-list-box"
              v-if="item.REPLY_OK === 'Y'"
              :class="{'active' : item.isActive}"
            >
              <div class="qna-title" @click="item.isActive = !item.isActive">
                  <span class="btn btn-sm btn-outline-gray status success">답변완료</span>
                  <p class="txt text-truncate">{{ item.SUBJECT }}</p>
                  <span class="chevron"><i></i></span>
              </div>
              <div class="qna-area">
                  <div class="qna-q">
                    <p class="txt">{{ item.SUBJECT }}</p>
                    <div class="question">
                        <div v-html="item.CONTENTS"></div>
                    </div>
                  </div>
                  <div class="qna-a">
                    <strong class="btn btn-sm btn-outline-danger">문의답변</strong>
                    <div class="answer">
                      <div v-html="item.REPLY"></div>
                    </div>
                </div>
              </div>
            </div>

            <div 
              v-else
              class="qna-list-box"
              :class="{'active' : item.isActive}"
            >
              <div class="qna-title" @click="item.isActive = !item.isActive">
                  <span class="btn btn-sm btn-outline-gray status ready">답변대기</span>
                  <p class="txt text-truncate">{{ item.SUBJECT }}</p>
                  <span class="chevron"><i></i></span>
              </div>
              <div class="qna-btn-box">
                <router-link :to="{ name:'QnaWrite', params:{ id: item.IDX }}">수정</router-link>
                <button type="button" class="btn btn-sm btn-danger" @click="onDelete(item.IDX)">삭제</button>
              </div>
              <div class="qna-area">
                  <div class="qna-q">
                    <p class="txt">{{ item.SUBJECT }}</p>
                    <div class="question">
                        <div v-html="item.CONTENTS"></div>
                    </div>
                  </div>
              </div>
            </div>
          </div>

          <div class="qna-list-box none" v-if="!qnaLists.length">
            문의 사항이 없습니다.
          </div>
        </div>

        <!-- 페이징 start -->
        <div class="paging-area" v-if="qnaLists.length">
          <v-pagination
            v-model="currentPage"
            :pages= numberOfPages
            :rangeSize="1"                 
            @update:modelValue="updateHandler(currentPage)"
          />
        </div>
        <!--// 페이징 end -->

      </div>
      <!-- //content end -->  

    </div>
    <!-- } Contents End -->

  </div>
  <!-- } Container End -->

  <boardDeleteModal
      v-if="showModal" 
      @close="closeModal" 
      @cancle="closeModal" 
      @ok="okModal" 
  />  
  
  <Footer/>
</template>

<script>

import { useStore } from 'vuex';
import { onMounted, ref, computed, getCurrentInstance } from 'vue';
import { useApicall } from '@/composables/commonFn';
import HeaderTrade from '@/components/HeaderTrade.vue';
import Footer from '@/components/Footer.vue';
import VPagination from "@hennge/vue3-pagination";
import boardDeleteModal from '@/components/popups/boardDeleteModal.vue';

export default {
  components:{  
    HeaderTrade, 
    Footer,
    VPagination,
    boardDeleteModal,
  },

  setup(){
    // const trace = getCurrentInstance().appContext.config.globalProperties.$log;    
    const emitter = getCurrentInstance().appContext.config.globalProperties.emitter;
    // const router = useRouter();
    const store = useStore();
    const { apiCall_gt } = useApicall();
    const qnaLists = ref([]);
    const limit = ref(10);
    const currentPage = ref(1)
    const numberOfData = ref(0);
    const numberOfPages = computed(()=>{
      return Math.ceil(numberOfData.value/limit.value)
    });
    const isLogin = computed(() => store.state.user.isLogin);
    const showModal = ref(false);
    const boardItemId = ref('');

    store.commit('trade/CHANGE_CURRENT_PAGE_ID', 'navi_Qna'); 
    store.commit('common/CHANGE_CURRENT_PAGE', 'Qna'); 

    onMounted(async ()=> {      
      emitter.emit('EVENT_CHECK_LOGIN');    
      updateHandler(1);
    })

    const updateHandler = (e) => {
      getQnaList(e);
    }

    const getQnaList = async( page = currentPage.value ) => {
      currentPage.value = page; 

      var offset = (currentPage.value -1)*limit.value;
      var getUrl = `board/counselinglist?limit=${limit.value}&offset=${offset}`;
      var qnaDataList = await apiCall_gt(getUrl)

      try {
        if(qnaDataList.dataList == null) qnaDataList.dataList = [];
        qnaLists.value = qnaDataList.dataList;
        numberOfData.value = qnaDataList.dataCount;
      } catch( error ) {
        emitter.emit('EVENT_ALERT',{title:"알림", body:"로그인이 필요합니다.\n로그인 후 이용하여 주십시오."});
        return false;
      }            
    }

    const deletCall = async (id) => {
      var res  =  await apiCall_gt(`board/counselingdelete/${id}`, 'DEL');
      if(res) { 
        emitter.emit('EVENT_ALERT',{title:"알림", body:"1:1 문의글이 삭제되었습니다."});
      }
      updateHandler(1);
    }

    const onDelete = (id) => {
      showModal.value = true;
      var getId = id;
      boardItemId.value = getId;
    }    

    const closeModal = () => {
      showModal.value = false; 
    }    

    const okModal = async() => {
      showModal.value = false; 
      deletCall(boardItemId.value);
      emitter.emit('EVENT_ALERT',{title:"알림", body:"1:1 문의글이 삭제되었습니다."});
      boardItemId.value = '';
    }

    return {
      qnaLists,
      isLogin,
      currentPage,
      numberOfPages,
      updateHandler,
      onDelete,
      showModal,
      closeModal,
      okModal,
      boardItemId,
    }
  }
}
</script>

<style>

</style>